import { SET_CLUSTER_LIST } from "../actions/types";

const initialState = false;

//Handling User
export const computeClusterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CLUSTER_LIST:
      return [...payload];
    default:
      return state;
  }
};
